"use client";

import type { WorkspaceField } from "@/lib/mlx-workspace-client";
import {
  columnWidthStyle,
  fluidColumnWidthStyle,
  usePersistedColumnSizing as useSharedPersistedColumnSizing,
} from "../../table-sizing";

export const TITLE_COLUMN_ID = "title";
export const ACTIONS_COLUMN_ID = "actions";

export function columnIdForField(field: WorkspaceField) {
  return `field:${field.id}`;
}
export function defaultFieldWidth(field: WorkspaceField) {
  if (field.type === "date" || field.type === "datetime") return 140;
  if (field.type === "number" || field.type === "currency" || field.type === "percent") return 120;
  if (field.type === "select") return 150;
  return 160;
}

export { columnWidthStyle, fluidColumnWidthStyle };

export function usePersistedColumnSizing(storageKey: string) {
  return useSharedPersistedColumnSizing(storageKey);
}
